module.exports = __webpack_public_path__ + "img/empty.4a6f39e2.png";